export const
    computeChartIndex = (isSpouse) => {
        return isSpouse ? 1 : 0;
    },
    computeChartStringKey = (owner, section, fpId, clientId) => {
        return `ILPC_${owner}_${section}_${fpId}_${clientId}`;
    },
    formatMoney = (value) => ADV.util.formatValue(ADV.util.numberFrom(value), 'money');